import React, { useCallback } from 'react';
import { Container, ImageWrapper, Wrapper, Image } from './Rolling.styled';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, SwiperOptions } from 'swiper';
import { IntersectionObserver } from '@/components/common';
import { clickEventHandler } from '@/helpers';
import { COMPONENT_TYPE, PLACEHOLDER_TOP_BANNER } from '@/const';
import { useCommonParams, useDeviceId } from '@/hooks';
import { IRollingInfo, IRollingItem } from '@/types';

SwiperCore.use([Autoplay]);

const Rolling = (props: IRollingInfo) => {
  const { ads = [] } = props;
  const [deviceId] = useDeviceId();
  const commonParams = useCommonParams();

  const swiperSettings: SwiperOptions = {
    slidesPerView: 1.125,
    spaceBetween: 10,
    centeredSlides: true,
    autoHeight: false,
    loop: ads ? ads.length > 1 : false,
    autoplay: ads.length > 1 ? { delay: 5000, disableOnInteraction: false } : false,
  };

  const handleClickSlide = useCallback(
    async (item: IRollingItem) => {
      await clickEventHandler({
        ...item,
        ...commonParams,
        deviceId,
        componentName: COMPONENT_TYPE.ROLLING,
      });
    },
    [deviceId, commonParams],
  );

  const renderComponent = (item: IRollingItem, index: number) => {
    return (
      <SwiperSlide key={index} onClick={() => handleClickSlide(item)}>
        <IntersectionObserver {...item} componentName={COMPONENT_TYPE.ROLLING}>
          <ImageWrapper>
            <Image
              src={item.imgPath || PLACEHOLDER_TOP_BANNER}
              alt={item.name || 'rolling image'}
              loading="lazy"
            />
          </ImageWrapper>
        </IntersectionObserver>
      </SwiperSlide>
    );
  };

  return (
    <Container>
      <Wrapper>
        <Swiper {...swiperSettings}>
          {ads?.map((item: IRollingItem, index) => renderComponent(item, index))}
        </Swiper>
      </Wrapper>
    </Container>
  );
};
export default Rolling;
